import React, { useState, useEffect } from 'react';

const TARGET = new Date('2026-05-30T19:00:00');

function pad(n) { return String(n).padStart(2, '0'); }

export default function Countdown() {
  const [time, setTime] = useState({ d: '00', h: '00', m: '00', s: '00' });

  useEffect(() => {
    const tick = () => {
      const diff = TARGET - new Date();
      if (diff <= 0) return;
      setTime({
        d: pad(Math.floor(diff / 86400000)),
        h: pad(Math.floor((diff % 86400000) / 3600000)),
        m: pad(Math.floor((diff % 3600000) / 60000)),
        s: pad(Math.floor((diff % 60000) / 1000)),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const unit = (val, label) => (
    <div style={{ textAlign: 'center' }}>
      <span style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(40px,6vw,68px)', lineHeight: 1, color: 'var(--white)', display: 'block' }}>{val}</span>
      <span style={{ fontSize: 9, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'rgba(245,240,232,0.35)', marginTop: 4, display: 'block' }}>{label}</span>
    </div>
  );

  return (
    <div style={{ background: 'var(--ash)', borderTop: '1px solid rgba(200,68,10,0.2)', borderBottom: '1px solid rgba(200,68,10,0.2)', padding: '48px 64px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 32 }}>
      <div>
        <p style={{ fontFamily: 'var(--font-body)', fontSize: 10, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 16 }}>REVIVE DALLAS— First Event Begins In</p>
        <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
          {unit(time.d, 'Days')}
          <span style={{ fontFamily: 'var(--font-display)', fontSize: 48, color: 'var(--ember)', opacity: 0.4, marginTop: -8 }}>:</span>
          {unit(time.h, 'Hours')}
          <span style={{ fontFamily: 'var(--font-display)', fontSize: 48, color: 'var(--ember)', opacity: 0.4, marginTop: -8 }}>:</span>
          {unit(time.m, 'Minutes')}
          <span style={{ fontFamily: 'var(--font-display)', fontSize: 48, color: 'var(--ember)', opacity: 0.4, marginTop: -8 }}>:</span>
          {unit(time.s, 'Seconds')}
        </div>
      </div>
      <p style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 'clamp(16px,2vw,22px)', color: 'rgba(245,240,232,0.4)', maxWidth: 320 }}>
        Your city is waiting for a generation that will not stay silent.
      </p>
    </div>
  );
}
